import ComponentMetricsBoundary from '@/components/ComponentMetricsBoundary/ComponentMetricsBoundary'
import getHotelLink from '@/shared-utils/get-hotel-link'
import type { ExtendStayTrip } from '@/types'
import { ExtendStayCard, UpcomingHotel } from '@pcln/trip-activity-components'
import { addDays } from 'date-fns/addDays'
import { parseISO } from 'date-fns/parseISO'
import { Box, Button, Flex, Heading, Relative } from 'pcln-design-system'
import { useEffect } from 'react'
import { fireViewTripClick } from '../CrossSell/ga4'
import fireExtendStayEvent from './ga4'
import generateThumbnailURL from './utils'

function ViewMyTrips() {
  return (
    <Button
      variation='subtle'
      size='small'
      onClick={() => {
        fireViewTripClick()
        window.open('/next-profile/trips')
      }}
      mb={[2, null, null, 0]}
    >
      View My Trips
    </Button>
  )
}

export default function ExtendStay({
  offerToken,
  travelStartDateTime,
  travelEndDateTime,
  cityName,
  stateName,
  hotelID,
  numRooms = 1,
  title,
  countryName,
}: ExtendStayTrip) {
  useEffect(() => {
    fireExtendStayEvent('view_promotion')
  })
  const endDate = parseISO(travelEndDateTime)
  const image = generateThumbnailURL(hotelID)

  return (
    <ComponentMetricsBoundary componentId='ExtendStay'>
      <Relative>
        <Flex justifyContent='space-between' px={1}>
          <Heading textStyle={['heading4', null, null, 'heading3']} color='text.heading' m={0} mb={3} as='h1'>
            Your Current Trip
          </Heading>
          <Box>
            <ViewMyTrips />
          </Box>
        </Flex>
        <Flex flexDirection={['column', null, null, 'row']}>
          <Box width={[1, null, null, 1 / 2]} px={1} mb={[2, null, null, 0]}>
            <UpcomingHotel
              hotelName={title}
              imageUrl={image}
              destination={`${cityName}, ${stateName || countryName}`}
              travelStartDate={travelStartDateTime}
              travelEndDate={travelEndDateTime}
              truncateHeading
              onClick={() => {
                fireViewTripClick()
                window.open(`/travel-itinerary/?offerToken=${offerToken}`)
              }}
            />
          </Box>
          <Box width={[1, null, null, 1 / 2]} px={1} mb={[2, null, null, 0]}>
            <ExtendStayCard
              cityName={cityName}
              onClick={() => {
                fireExtendStayEvent('select_promotion')
                window.open(getHotelLink(hotelID, endDate, addDays(endDate, 1), numRooms))
              }}
            />
          </Box>
        </Flex>
      </Relative>
    </ComponentMetricsBoundary>
  )
}
